window.jQuery = window.$ = require("jquery");
var processInclude = require("base/util");

// modify the events to be passive by default
require("coremh/components/enablePasiveEvents");

$(document).ready(function () {
    processInclude(require("base/components/cookie"));
    processInclude(require("./components/clientSideValidation"));
    processInclude(require("base/components/toolTip"));
    processInclude(require("./components/miniCart"));
    processInclude(require("coremh/components/initSelect2"));
    processInclude(require("./components/menu"));
    processInclude(require("coremh/components/headerCarousel"));
    processInclude(require("coremh/components/backToTop"));
    processInclude(require("coremh/components/collapsibleItem"));
    processInclude(require("coremh/components/inputFocus"));
    processInclude(require("./components/newsletter"));
    processInclude(require("coremh/components/header"));
    processInclude(require("./components/initSlickSlider"));
    processInclude(require("coremh/components/veil"));
    processInclude(require("coremh/components/search"));
    processInclude(require("./product/producttile"));
    processInclude(require("coremh/components/cartCounter"));
    processInclude(require("./components/passwordToggle"));
    processInclude(require("./components/login"));
    processInclude(require("coremh/components/cookieSetup"));
    processInclude(require("google/initRecaptcha"));
    processInclude(require("./script"));
    processInclude(require("corecountryselector/countrySelector/countrySelector"));
});

require("coremh/thirdParty/bootstrap");
require("base/components/spinner");
require("coremh/thirdParty/lazysizes.min");
require("coremh/thirdParty/slick");
require("coremh/thirdParty/select2.min");
window.debounce = require("lodash/debounce");
